// This component takes a canvaId as a prop to render a particular iframe. These pages live in canva and the id comes from the unique part of each embed url.

export default function CanvaEmbed({ canvaId }) {
  const url = `https://www.canva.com/design/${canvaId}/view?embed`;

  return (
    <div className="update-data">
      <div
        style={{
          width: "100%",
          height: "1000px",
        }}
      >
        <iframe
          loading="lazy"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            padding: 0,
            margin: 0,
          }}
          src={url}
          allowFullScreen
          allow="fullscreen"
          title="Best Practices"
        ></iframe>
      </div>
    </div>
  );
}
